import React from "react";
import { Button } from "aible";

import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";

import styles from "./style.module.css";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/aible/Dialog/Dialog";

export default class CommentModal extends React.Component {
  constructor(props) {
    super(props);
    const { comment } = this.props;

    this.state = {
      id: comment?.id || this.props.nextId,
      nextId: comment?.nextId || this.props.nextId,
      title: comment?.title || "",
      subTitle: comment?.subTitle || "",
      textBody: comment?.textBody || "",
      cHoursAgo: comment?.cHoursAgo || 0,
      contractType: comment?.contractType || "",
      contractLength: comment?.contractLength || "",
      budget: 120,
      maxBudget: 500,
      rateType: comment?.rateType || "Per Hour",
      assignee: "Jane C."
    };
  }

  componentDidUpdate(prevProps) {
    const { comment } = this.props;

    if (comment !== undefined && prevProps.comment === undefined) {
      this.setState({
        id: comment.id,
        nextId: comment.nextId,
        title: comment.title,
        subTitle: comment.subTitle,
        textBody: comment.textBody,
        cHoursAgo: comment.cHoursAgo,
        contractType: comment.contractType,
        contractLength: comment.contractLength,
        rateType: comment.rateType,
        assignee: comment.assignee,
        node: comment.node
      });
    }
  }

  renderNoModal() {
    const { createComment, task } = this.props;

    const { textBody, isAddingComment } = this.state;

    return (
      <div id={"commentModal"}>
        <div className={styles.jobInput}>
          <div className={styles.bTitle}>{"Enter Comment: "}</div>
          <div className={styles.commentRight}>
            <textarea
              className={styles.jobDescription}
              onChange={(e) => this.setState({ textBody: e.target.value })}
              value={textBody}
            />
          </div>
        </div>
        <div className={styles.modalFooter} style={{ width: "100%", display: "flex", justifyContent: "center" }}>
          {isAddingComment ? (
            <LoadingIndicator
              style={{
                margin: "0px",
                marginTop: "-10px",
                transform: "scale(0.5)"
              }}
            />
          ) : (
            <Button
              type="primary"
              onClick={() => {
                this.setState({ isAddingComment: true, textBody: "" });
                setTimeout(() => this.setState({ isAddingComment: false }), 500);

                createComment({
                  ...this.state,
                  node: { id: task?.title || task?.id },
                  date: new Date()
                });
              }}
              disabled={textBody === undefined || textBody === ""}
            >
              {"Add Comment"}
            </Button>
          )}
        </div>
      </div>
    );
  }

  render() {
    const { updateIsCommentModal, comment, createComment, isNoModal } = this.props;

    if (isNoModal) {
      return this.renderNoModal();
    }

    const { id, textBody } = this.state;

    return (
      <div id={"commentModal"}>
        <Dialog open={comment !== undefined} onOpenChange={() => updateIsCommentModal(undefined)}>
          <DialogContent>
            <DialogHeader>
              <DialogTitle>
                <div className={styles.boldItem}>{"Create Comment: " + comment?.node?.text}</div>
              </DialogTitle>
            </DialogHeader>
            <div className={styles.jobInput}>
              <div className={styles.bTitle}>{"Enter Comment: "}</div>
              <div>
                <textarea
                  className={styles.jobDescription}
                  onChange={(e) => this.setState({ textBody: e.target.value })}
                  value={textBody}
                />
              </div>
            </div>
            <DialogFooter>
              <Button type="secondary" onClick={() => updateIsCommentModal(undefined)} style={{ marginRight: "auto" }}>
                {"Close"}
              </Button>
              <Button type="primary" onClick={() => createComment({ ...this.state })}>
                {id !== undefined ? "Update" : "Create"}
              </Button>
            </DialogFooter>
          </DialogContent>
        </Dialog>
      </div>
    );
  }
}
